import './App.css';
import Layout from './layouts/Layout'



function App() {
  let body
  body = (
    <>
      <Layout />
    </>

  )
  return (
    <>
      {body}

    </>
  );
}

export default App;
